import { AssetWithPresignedUrl } from '@droidmap/asset-service-contract'
import { Manifest } from '@droidmap/asset-service-contract'

export interface TextureMap {
  [key: string]: string
}

const MODEL_FOLDER = 'odm_texturing'
const SUPPORTED_EXTENSIONS = {
  MODEL: '.obj',
  MATERIAL: '.mtl',
  TEXTURE: '.png',
} as const

export const filterModelFiles = (assets: AssetWithPresignedUrl[]) => {
  return assets.filter((asset) => asset.folderPath === MODEL_FOLDER)
}

export const filterManifestModelFiles = (manifest: Manifest) => {
  return manifest.files.filter((file) => file.filePath.includes(MODEL_FOLDER))
}

export const createTextureMap = (
  modelFiles: AssetWithPresignedUrl[],
): TextureMap => {
  return modelFiles.reduce((map, file) => {
    if (file.name.endsWith(SUPPORTED_EXTENSIONS.TEXTURE)) {
      map[file.name] = file.presignedUrl
    }
    return map
  }, {} as TextureMap)
}

export const findObjFile = (modelFiles: AssetWithPresignedUrl[]) => {
  return modelFiles.find((file) =>
    file.name.endsWith(SUPPORTED_EXTENSIONS.MODEL),
  )
}

export const getMtlUrls = (modelFiles: AssetWithPresignedUrl[]) => {
  return modelFiles
    .filter((file) => file.name.endsWith(SUPPORTED_EXTENSIONS.MATERIAL))
    .map((file) => file.presignedUrl)
}
